import clsx from 'clsx'

interface ButtonProps {
  onClick: (event: any) => void
  text: string
  disabled?: boolean
  iconStart?: React.ReactNode
  loading?: boolean
  iconEnd?: React.ReactNode
  variant?: 'primary' | 'secondary'
  theme?: 'light' | 'dark'
  size?: 'normal' | 'small' | 'fit'
  className?: string
}

export const Button = ({
  onClick,
  text,
  iconStart,
  iconEnd,
  loading,
  variant = 'primary',
  theme = 'light',
  className,
  size = 'normal',
  ...props
}: ButtonProps) => {
  function getThemeClasses() {
    switch (true) {
      case variant === 'primary' && theme === 'light':
        return 'bg-black text-white hover:bg-[#6E6E6E] disabled:bg-[#D4D4D4] disabled:text-[#6E6E6E] [&_path]:fill-white'
      case variant === 'secondary' && theme === 'light':
        return 'bg-white text-black border-2 border-solid border-black hover:bg-[#D4D4D4] disabled:text-[#D4D4D4] disabled:border-[#D4D4D4]'
      case variant === 'primary' && theme === 'dark':
        return 'bg-white text-black hover:bg-[#6E6E6E] disabled:bg-[#D4D4D4] disabled:text-[#6E6E6E]'
      case variant === 'secondary' && theme === 'dark':
        return 'bg-black text-white border-2 border-solid border-white hover:bg-[#D4D4D4] disabled:text-[#9B9B9B] disabled:border-[#9B9B9B]'
    }
  }
  function getSizeClasses() {
    switch (size) {
      case 'small':
        return 'w-[168px] h-9'
      case 'fit':
        return 'w-fit h-10 py-2.5 px-4'
      default:
        return 'w-[327px] h-10'
    }
  }
  return (
    <button
      onClick={onClick}
      disabled={loading || props.disabled}
      className={clsx(
        'text-[14px] leading-[22px] font-bold rounded-[100px] flex items-center gap-2 disabled:cursor-not-allowed',
        getSizeClasses(),
        getThemeClasses(),
        className,
      )}
      {...props}
    >
      {iconStart}
      {text}
      {iconEnd}
    </button>
  )
}
